<div fxLayout="column" fxLayoutAlign="center center">
  <div class="title-container" fxLayout fxLayoutAlign="center center">
    <h1>{{ confirmationMessageTitle }}</h1>
  </div>
  @if (confirmationMessage) {
    <span
      class="confirmation-message"
      [innerHTML]="confirmationMessage | safeHtml"
    ></span>
  } @else {
    {{
      isAdded
        ? 'You have been added to the system.'
        : 'You have been updated in the system.'
    }}
  }
  @if (invoice) {
    <div class="container">
      <app-payment-confirmation
        [invoice]="invoice"
        [checkInstructions]="checkInstructions"
        [isConfirmationPage]="true"
      ></app-payment-confirmation>
    </div>
  }
  <br />
</div>
